const LOVES_LIST = 'Loves';
const LOVES_LIST_MAX = 1000;
const OTHER_LIST_MAX = 100;
const MAX_CUSTOM_LISTS = 10;
const COPY_LINK_TIMEOUT = 2000;
const LOVES_URL = '/profile/Lists';
const PRODUCT_CARD_WIDTH = ['295px', null, '408px'];
const MAX_ONLY_A_FEW_LEFT_IN_LOVES_LIST_FLYOUT = 5;

export {
    LOVES_LIST,
    LOVES_LIST_MAX,
    OTHER_LIST_MAX,
    MAX_CUSTOM_LISTS,
    COPY_LINK_TIMEOUT,
    LOVES_URL,
    PRODUCT_CARD_WIDTH,
    MAX_ONLY_A_FEW_LEFT_IN_LOVES_LIST_FLYOUT
};
